import Fetch from '../Fetch';

export default {
  queryPortMirroringInfo: (params) => {
    return Fetch.get(`/api/v1/sw_portmirroring`, { params });
  },

  switchPortMirroring: (params) => {
    return Fetch.post(`/api/v1/sw_portmirroring`, params);
  },

  updatePortMirroring: (params) => {
    return Fetch.post(`/api/v1/sw_portmirroring`, params);
  },
};
